module.exports = __webpack_public_path__ + "a560695d5f2b460f63aa5fa650f829c9.png";